export default __webpack_public_path__ + "static/careers-benefits-block1-icon04.url-12b09d260ad56d67d8ba7ea0845ea4dd.svg";